import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'react-bootstrap';

import Layout from '../Layout';
import Seo from '../component/Seo';
import { langPathSuffix } from '../lang-utils';
import Service from '../component/ServiceSection';

const SEO = {
  lt: {
    title: 'Tralo paslaugos Kaune ir visoje Lietuvoje | Geltonas Traliukas',
    description: 'Visos tralo paslaugos vienoje vietoje: lengvųjų automobilių, motociklų, visureigių, mikroautobusų, krovinių iki 3t pervežimas. Pagalba kelyje 24/7.',
    h1: 'Tralo paslaugos Kaune ir visoje Lietuvoje',
    intro: 'Mūsų komanda teikia profesionalias tralo ir pagalbos kelyje paslaugas Kauno mieste ir visoje Lietuvos teritorijoje. Greitai atvykstame, saugiai pakrauname ir pristatome jūsų transporto priemonę į nurodytą vietą.',
    crossTitle: 'Daugiau informacijos',
    crossFaq: 'Dažniausiai užduodami klausimai',
    crossGallery: 'Pažiūrėkite darbų galeriją',
    crossContact: 'Susisiekite su mumis'
  },
  en: {
    title: 'Tow truck services in Kaunas and Lithuania | Geltonas Traliukas',
    description: 'All tow truck services in one place: cars, motorcycles, off-road vehicles, minibuses and cargo up to 3t. Roadside assistance 24/7.',
    h1: 'Tow truck services in Kaunas and throughout Lithuania',
    intro: 'Our team provides professional tow truck and roadside assistance services in Kaunas and across Lithuania. We arrive quickly, load your vehicle safely and deliver it to the agreed destination.',
    crossTitle: 'More information',
    crossFaq: 'Frequently asked questions',
    crossGallery: 'See our work gallery',
    crossContact: 'Get in touch'
  },
  ru: {
    title: 'Услуги эвакуатора в Каунасе и по всей Литве | Geltonas Traliukas',
    description: 'Все услуги эвакуатора в одном месте: легковые авто, мотоциклы, внедорожники, микроавтобусы, грузы до 3т. Помощь на дороге 24/7.',
    h1: 'Услуги эвакуатора в Каунасе и по всей Литве',
    intro: 'Наша команда предоставляет профессиональные услуги эвакуатора и помощи на дороге в Каунасе и по всей Литве. Быстро приезжаем, бережно грузим и доставляем ваш автомобиль в нужное место.',
    crossTitle: 'Больше информации',
    crossFaq: 'Часто задаваемые вопросы',
    crossGallery: 'Галерея работ',
    crossContact: 'Связаться с нами'
  }
};

function PaslaugosPage({ lang = 'lt' }) {
  const t = SEO[lang] || SEO.lt;
  return (
    <Layout
      lang={lang}
      renderChildren={({ strings, pageWidth, onTop }) => {
        return (
          <>
            <Seo path="/paslaugos/" lang={lang} title={t.title} description={t.description} pageName={strings.navbar.service} />
            <Container className="section-padding">
              <div className="text-center">
                <h1 className="section-title">{t.h1}</h1>
                <div className="section-underline" />
              </div>
              <p className="text-justify page-intro">{t.intro}</p>
            </Container>
            <Service strings={strings} onTop={onTop} pageWidth={pageWidth} section="light" hideTitle lang={lang} />
            <Container className="section-padding">
              <h2 className="text-center">{t.crossTitle}</h2>
              <ul className="cross-links">
                <li><Link to={`/duk/${langPathSuffix(lang)}`}>{t.crossFaq}</Link></li>
                <li><Link to={`/galerija/${langPathSuffix(lang)}`}>{t.crossGallery}</Link></li>
                <li><Link to={`/kontaktai/${langPathSuffix(lang)}`}>{t.crossContact}</Link></li>
              </ul>
            </Container>
          </>
        );
      }}
    />
  );
}

export default PaslaugosPage;
